<template>
  <div class="p-inputgroup">
    <AutoComplete v-model="selectedOrder" placeholder="Sök efter ordrar..." :suggestions="filteredOrders" @complete="searchOrder($event)" field="id">
      <template #item="slotProps">
        <div v-on:click="orderDetails(slotProps.item)">Order {{slotProps.item.id}}
          <span v-if="slotProps.item.type != 'feralcoIntern'">
            <span v-if="slotProps.item.data.SalesId"> {{slotProps.item.data.SalesId}} </span>
            <span v-if="slotProps.item.data.DeliveryPlaceCity">Leveransställe {{slotProps.item.data.DeliveryPlaceCity}} </span>
            <span v-else>{{slotProps.item.data.CustomerPlaces[0].data.name}}</span>
          </span>
          <span v-else>Internorder {{slotProps.item.data.fraktsedelNr}}</span>
        </div>
      </template>
    </AutoComplete>
    <span class="p-inputgroup-addon">
      <i class="pi pi-search" />
    </span>
  </div>
</template>
<script>
import AutoComplete from 'primevue/autocomplete'
export default {
  name: 'searchOrders',
  components: {
    AutoComplete
  },
  data () {
    return {
      selectedOrder: null,
      filteredOrders: null,
      customerId: null
    }
  },
  created () {
    if (localStorage.getItem('userCustomerId')) {
      this.userCustomerId = localStorage.getItem('userCustomerId')
    }
  },
  methods: {
    async searchOrder (event) {
      let callApi = '/api/orders/search/' + event.query
      if (this.userCustomerId !== 'null') {
        callApi = '/api/orders/search/by-user/' + this.userCustomerId + '/' + event.query
      }
      await this.$http
        .get(callApi)
        .then(response => {
          this.filteredOrders = response.data
        })
        .catch(error => console.log(error))
    },
    async orderDetails (order) {
      let schema = await this.$http.get('/api/orders/schema/' + order.type)
      if (order.type === 'feralco') {
        this.$router.push({ name: 'FeralcoOrdersDetails', params: { id: order.id, order: order, schema: schema.data.schema } })
      } else if (order.type === 'feralcoIntern') {
        this.$router.push({ name: 'FeralcoInternOrderDetails', params: { id: order.id, order: order, schema: schema.data.schema } })
      } else {
        this.$router.push({ name: 'OrderDetails', params: { id: order.id, order: order, schema: schema.data.schema } })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/searchOrders.vue